import SendEmailPromptController from 'servicestack/email/send-email-prompt.controller'
import modals from 'webmodals/modals'
import $session from 'servicestack/session'

export default class CreditMemoPromptController extends SendEmailPromptController {
  constructor(options) {
    super(options);
  }

  getCommandUrl() {
    const $ctrl = this;
    return `${$ctrl.model.id ? 'Upd' : 'Cre'}ateCreditMemoRequest.json?jsconfig=ua,uaa`;
  }

  onSubmitted(res) {
    super.onSubmitted(res);
    const $ctrl = this;
    console.info("onSubmitted Prompt");
    if ($ctrl.options.transitionTo) {
      $ctrl.$state.transitionTo($ctrl.options.transitionTo, {
        retailerId: $ctrl.options.retailerId,
        id: res.data.id
      });
    }
  }

  delete() {
    const $ctrl = this;
    $ctrl.$close($ctrl.model);
    return modals.confirm("Are you sure?", "Delete Credit").result
      .then(() => $ctrl.bus.send('DeleteCreditMemoRequest.json', $ctrl.model));
  }
};